import gql from 'graphql-tag';

// Mutation gets back the necessary things to update service run status docket list.

const MANUAL_RESTOCK = gql`
	mutation manualRestock (
		$serviceDocketId: ID!,
		$communicationId: ID,
		$manualRestockApprovedBy: ID,
		$manualRestockComment: String,
		$queuedOffline: Boolean,
		$adminTraining: Boolean,
	) {
		manualRestock (
			serviceDocketId: $serviceDocketId,
			communicationId: $communicationId,
			manualRestockApprovedBy: $manualRestockApprovedBy,
			manualRestockComment: $manualRestockComment,
			queuedOffline: $queuedOffline,
			adminTraining: $adminTraining,
		) {
			id
			status
			date
			inventoryCheck
			replacementReviewRequired
			replacementReviewReason
			manualRestock
			manualRestockApprovedBy {
				id
				firstname
				lastname
			}
			manualRestockComment
			isRestocked
			startedProcessing
			cashCollected
			salesSinceLastRestock
			coinsSinceLastCollection
			notesSinceLastCollection
			cashSinceLastCollection
			machine {
				id
				vendouts
				percentageFull
				daysSinceLastService
			}
		}
	}
`;


export default MANUAL_RESTOCK;
